const currencyCodes = require('currency-codes')

module.exports = function() {
  return function(value) {
    return value === value.toUpperCase() && !!currencyCodes.code(value)
  }
}
